/**
 * @generated SignedSource<<6179ae3b4383c717a09eb2df6a0c4197>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersStyleSectionContent$data = {
  readonly fullSectionPath: ReadonlyArray<{
    readonly entityId: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "helpersStyleSectionContent";
};
export type helpersStyleSectionContent$key = {
  readonly " $data"?: helpersStyleSectionContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersStyleSectionContent">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersStyleSectionContent"
};

(node as any).hash = "8fb78ac80350a40219d45adb8c0539b5";

export default node;
